var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{ref:"input",attrs:{"value":_vm.value,"formatter":_vm.formatter,"state":_vm.state},on:{"input":_vm.updateValue,"focus":_vm.selectAll}})}
var staticRenderFns = []

export { render, staticRenderFns }